import type { EvaluationMode } from '../../types';
export function EvaluationModeTabs({
  value,
  onChange
}: {
  value: EvaluationMode;
  onChange: (value: EvaluationMode) => void;
}) {
  return (
    <div className="segmented" role="tablist" aria-label="评测模式">
      {(['single', 'compare'] as const).map((mode) => (
        <button
          type="button"
          key={mode}
          role="tab"
          aria-selected={value === mode}
          tabIndex={value === mode ? 0 : -1}
          className={value === mode ? 'active' : ''}
          onClick={() => onChange(mode)}
        >
          {mode === 'single' ? '单篇评估' : '双篇对比'}
        </button>
      ))}
    </div>
  );
}
